import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Marcher dans le virtuel",
    text: "Nos 5 tapis omnidirectionnels KAT VR Walk Mini transposent chacun de vos pas dans le jeu. Courez, esquivez, explorez : votre corps est la manette.",
  },
  {
    n: "02",
    title: "Sensations 360°",
    text: "La chaise gyroscopique vous retourne littéralement le cerveau : rotations complètes, vibrations haptiques et loopings en toute sécurité.",
  },
  {
    n: "03",
    title: "L'esport grandeur nature",
    text: "Affrontez vos amis en arène coopérative ou compétitive, jusqu'à 6 joueurs simultanés sur le même champ de bataille virtuel.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="font-hud text-xs uppercase tracking-[0.35em] text-cyan-400"
      >
        {"// Le manifeste"}
      </motion.p>
      <div className="mt-14 grid gap-10 md:grid-cols-3 md:gap-8">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.15, duration: 0.7 }}
            className="border-t-2 border-line pt-6"
          >
            <span className="text-stroke-cyan font-orbitron text-6xl font-black">
              {c.n}
            </span>
            <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-wide text-slate-100">
              {c.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
